import { useState } from "react";
import { useIntl } from "react-intl";
import { Button, Modal, Table } from "semantic-ui-react";
import { toast } from "../..";
import { translatedRoles, UserData } from "../../actions/authentificationActions";
import { deleteUser } from "../../api/users";
import { EditUserForm } from "./EditUserForm";

type Props = {
    fetchUsers: () => Promise<void>;
    user: UserData;
    handleRemoveUser: (userGuid: string) => void;
};

export const UsersTableRow = ({ user, handleRemoveUser, fetchUsers }: Props) => {
    const intl = useIntl();
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    const handleDeleteUser = async () => {
        try {
            await deleteUser(user.guid!);
            handleRemoveUser(user.guid!);
            toast(intl.formatMessage({ id: "userDeleted" }), true);
        } catch {
            toast(intl.formatMessage({ id: "unableToDeleteUser" }), false);
        } finally {
            setDeleteModalOpen(false);
        }
    };

    return (
        <>
            <Table.Row>
                <Table.Cell>
                    {user.firstName} {user.lastName} ({user.username})
                </Table.Cell>
                <Table.Cell>{user.authority}</Table.Cell>
                <Table.Cell singleLine>
                    {translatedRoles.find(r => r.en === user.role)![intl.locale]}
                </Table.Cell>
                <Table.Cell width={1} singleLine>
                    <span className="buttons-container">
                        <Button
                            content={intl.formatMessage({ id: "edit" })}
                            basic
                            color="blue"
                            size="small"
                            onClick={() => setEditModalOpen(true)}
                        />
                        <Button
                            content={intl.formatMessage({ id: "delete" })}
                            negative
                            basic
                            size="small"
                            onClick={() => setDeleteModalOpen(true)}
                        />
                    </span>
                </Table.Cell>
            </Table.Row>
            <Modal
                open={deleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}
                dimmer="blurring"
                size="tiny"
            >
                <Modal.Header>{intl.formatMessage({ id: "areYouSureDeleteUser" })}</Modal.Header>
                <Modal.Actions>
                    <Button
                        negative
                        onClick={() => setDeleteModalOpen(false)}
                        content={intl.formatMessage({ id: "cancel" })}
                    />
                    <Button
                        primary
                        onClick={() => handleDeleteUser()}
                        content={intl.formatMessage({ id: "confirm" })}
                    />
                </Modal.Actions>
            </Modal>
            <EditUserForm
                user={user}
                open={editModalOpen}
                close={() => setEditModalOpen(false)}
                fetchUsers={fetchUsers}
            />
        </>
    );
};
